import { FC, ReactNode } from 'react'

import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.unchangingColor.black};
  padding: 24px;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  color: ${({ theme }) => theme.unchangingColor.white};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

const Arrow = styled.span`
  position: absolute;
  right: calc(50% - 9px);
  bottom: -8px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-top: 9px solid ${({ theme }) => theme.unchangingColor.black};
`

type Props = {
  children: ReactNode
}

export const CouponBonusTooltip: FC<Props> = ({ children }) => (
  <Container>
    <span>🎁</span>
    <span>{children}</span>
    <Arrow />
  </Container>
)
